// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../col/Col'
import {Icon} from '../icon/Icon'
import {Input} from '../input/Input'
import {Select} from '../select/Select'
import {SelectOption} from '../select/option/SelectOption'
import {Row} from '../row/Row'

@Component({
    name: 'Pagination',
    components: {
        Col,
        Icon,
        Input,
        Select,
        SelectOption,
        Row,
    },
    mixins: [
        template,
    ]
})
export class Pagination extends Vue {

    // Getters
    public get totalPages() {

        return this.pageCount || Math.ceil(this.total / this.localPageSize)
    }

    public get fromToItem() {

        const from = this.total == 0 ? 0 : ((this.localCurrentPage - 1) * this.localPageSize) + 1
        const to = this.localCurrentPage * this.localPageSize < this.total ? this.localCurrentPage * this.localPageSize : this.total 

        return `${from}-${to}`
    }

    public get paginationItems() {

        if (this.totalPages <= 7) {
            return [...Array(this.totalPages).keys()].map(item => item + 1)
        }

        let items: any[] = [1]

        if (this.localCurrentPage <= 4) {
            items = items.concat([...Array(5).keys()].map(item => item + 2))
            items.push('shift')
        } else if (this.localCurrentPage >= (this.totalPages - 4)) {

            items.push('unshift')
            items = items.concat([...Array(5).keys()].map(item => (this.totalPages - 5) + item))
        } else if (this.localCurrentPage > 4 && this.localCurrentPage < (this.totalPages - 4)) {

            items.push('unshift')
            items = items.concat([...Array(5).keys()].map(item => (this.localCurrentPage - 2) + item))
            items.push('shift')
        }

        items.push(this.totalPages)

        return items
    }

    public localCurrentPage: number = 1
    public localPageSize: number = 10

    @Prop({default: 1})
    public currentPage!: number

    @Prop({default: 1})
    public total!: number

    @Prop()
    public pageCount!: number

    @Prop({default: 10})
    public pageSize!: number

    @Prop({default: () => [5, 10, 25, 100]})
    public pageSizeOptions!: number[]

    @Prop({default: () => ({total: true, size: true, pages: true})})
    public parts!: object

    @Prop({default: () => ({})})
    public translations!: object

    // Watchers
    @Watch('currentPage')
    public watchPageSizeProp(currentPage) {
        if (this.localCurrentPage != currentPage) this.localCurrentPage = currentPage
    }

    @Watch('pageSize')
    public watchCurrentPageProp(pageSize) {
        if (this.localPageSize != pageSize) this.localPageSize = pageSize
    }

    public created () {
        this.localCurrentPage = this.currentPage
        this.localPageSize = this.pageSize
    }

    public handlePageSelect(page: string | number) {

        if (
            (page === 'first' && this.localCurrentPage === 1) ||
            (page === 'prev' && this.localCurrentPage === 1) ||
            (page === 'last' && this.localCurrentPage === this.totalPages) ||
            (page === 'next' && this.localCurrentPage === this.totalPages) ||
            (page === this.localCurrentPage)
        ) return

        if (page === 'first') {
            this.localCurrentPage = 1
        } else if (page === 'prev') {
            this.localCurrentPage > 1 ? --this.localCurrentPage : undefined
            this.$emit('prev', this.localCurrentPage)
        } else if (page === 'unshift') {
            this.localCurrentPage = (this.localCurrentPage - 3) >= 1 ? this.localCurrentPage - 3 : 1
        } else if (page === 'shift') {
            this.localCurrentPage = (this.localCurrentPage + 3) <= this.totalPages ? this.localCurrentPage + 3 : this.totalPages
        } else if (page === 'next') {
            this.localCurrentPage < this.totalPages ? ++this.localCurrentPage : undefined
            this.$emit('next', this.localCurrentPage)
        } else if (page === 'last') {
            this.localCurrentPage = this.totalPages
        } else {
            this.localCurrentPage = page as number
        }

        this.$emit('update:currentPage', this.localCurrentPage)
        this.$emit('current', this.localCurrentPage)
    }

    public handlePageSizeChange(pageSize) {
        this.localPageSize = pageSize

        this.handlePageSelect(1)

        this.$emit('update:pageSize', this.localPageSize)
        this.$emit('page-size', pageSize)
    }
}